import { TabsListUnstyled } from '@mui/base'
import { styled } from '@mui/material'
import useGetTabListTemplate
  from '~/src/components/mui-wrappers/styled/delivery-methods/tab-list/styles/useGetTabListTemplate'

const DeliveryMethodTabList = styled(TabsListUnstyled)(() => useGetTabListTemplate().getComponentSx())

export default DeliveryMethodTabList
